import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/CheckboxGroup/CheckboxGroup.docs.json';
import { CheckboxGroup, Checkbox, Box } from '@primer/components';
import { CheckIcon, XIcon, AlertIcon } from '@primer/octicons-react';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <DeprecationBanner replacementUrl={'/components/checkbox-group/react/latest'} mdxType="DeprecationBanner" />
    <h2>{`Examples`}</h2>
    <h3>{`Basic`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="grid" sx={{gap: 3}}>
  <CheckboxGroup>
    <CheckboxGroup.Label>Choices</CheckboxGroup.Label>
    <FormControl>
      <Checkbox value="one" />
      <FormControl.Label>Choice one</FormControl.Label>
    </FormControl>
    <FormControl>
      <Checkbox value="two" />
      <FormControl.Label>Choice two</FormControl.Label>
    </FormControl>
    <FormControl>
      <Checkbox value="three" />
      <FormControl.Label>Choice three</FormControl.Label>
    </FormControl>
  </CheckboxGroup>
</Box>
`}</code></pre>
    <h3>{`Using onChange handlers`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const WithOnChangeHandlers = () => {
  const [selectedCheckboxValues, setSelectedCheckboxValues] = React.useState(['one', 'two'])
  const [lastSelectedCheckboxValue, setLastSelectedCheckboxValue] = React.useState()

  const handleCheckboxGroupChange = (selectedValues, e) => {
    setSelectedCheckboxValues(selectedValues)
    setLastSelectedCheckboxValue(e.currentTarget.value)
  }

  const handleChoiceOneChange = e => {
    alert('Choice one has its own handler')
  }

  return (
    <Box display="grid" sx={{gap: 1}}>
      <CheckboxGroup onChange={handleCheckboxGroupChange}>
        <CheckboxGroup.Label>Choices</CheckboxGroup.Label>
        <FormControl>
          <Checkbox value="one" defaultChecked onChange={handleChoiceOneChange} />
          <FormControl.Label>Choice one</FormControl.Label>
        </FormControl>
        <FormControl>
          <Checkbox value="two" defaultChecked />
          <FormControl.Label>Choice two</FormControl.Label>
        </FormControl>
        <FormControl>
          <Checkbox value="three" />
          <FormControl.Label>Choice three</FormControl.Label>
        </FormControl>
      </CheckboxGroup>

      {Boolean(selectedCheckboxValues.length) && (
        <div>The selected checkbox values are {selectedCheckboxValues.join(', ')}</div>
      )}
      {Boolean(lastSelectedCheckboxValue) && <div>The last affected checkbox value is {lastSelectedCheckboxValue}</div>}
    </Box>
  )
}

render(<WithOnChangeHandlers />)
`}</code></pre>
    <h3>{`Disabled`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<CheckboxGroup disabled>
  <CheckboxGroup.Label>Choices</CheckboxGroup.Label>
  <FormControl>
    <Checkbox value="one" />
    <FormControl.Label>Choice one</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox value="two" />
    <FormControl.Label>Choice two</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox value="three" />
    <FormControl.Label>Choice three</FormControl.Label>
  </FormControl>
</CheckboxGroup>
`}</code></pre>
    <h3>{`Required`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<CheckboxGroup required>
  <CheckboxGroup.Label>Choices</CheckboxGroup.Label>
  <FormControl>
    <Checkbox value="one" />
    <FormControl.Label>Choice one</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox value="two" />
    <FormControl.Label>Choice two</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox value="three" />
    <FormControl.Label>Choice three</FormControl.Label>
  </FormControl>
</CheckboxGroup>
`}</code></pre>
    <h3>{`With validation`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<CheckboxGroup>
  <CheckboxGroup.Label>Choices</CheckboxGroup.Label>
  <FormControl>
    <Checkbox value="one" />
    <FormControl.Label>Choice one</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox value="two" />
    <FormControl.Label>Choice two</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox value="three" />
    <FormControl.Label>Choice three</FormControl.Label>
  </FormControl>
  <CheckboxGroup.Validation variant="error">Your choices are wrong</CheckboxGroup.Validation>
</CheckboxGroup>
`}</code></pre>
    <h3>{`With caption`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<CheckboxGroup>
  <CheckboxGroup.Label>Choices</CheckboxGroup.Label>
  <CheckboxGroup.Caption>You can pick any or all of these choices</CheckboxGroup.Caption>
  <FormControl>
    <Checkbox value="one" />
    <FormControl.Label>Choice one</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox value="two" />
    <FormControl.Label>Choice two</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox value="three" />
    <FormControl.Label>Choice three</FormControl.Label>
  </FormControl>
</CheckboxGroup>
`}</code></pre>
    <h3>{`A visually hidden label`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<CheckboxGroup>
  <CheckboxGroup.Label visuallyHidden>Choices</CheckboxGroup.Label>
  <FormControl>
    <Checkbox value="one" />
    <FormControl.Label>Choice one</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox value="two" />
    <FormControl.Label>Choice two</FormControl.Label>
  </FormControl>
  <FormControl>
    <Checkbox value="three" />
    <FormControl.Label>Choice three</FormControl.Label>
  </FormControl>
</CheckboxGroup>
`}</code></pre>
    <h3>{`With an external label`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Box
    id="choiceHeading"
    borderBottomWidth="1px"
    borderBottomStyle="solid"
    borderBottomColor="border.default"
    pb={2}
    mb={3}
    fontSize={3}
  >
    Choices
  </Box>
  <CheckboxGroup aria-labelledby="choiceHeading">
    <FormControl>
      <Checkbox value="one" />
      <FormControl.Label>Choice one</FormControl.Label>
    </FormControl>
    <FormControl>
      <Checkbox value="two" />
      <FormControl.Label>Choice two</FormControl.Label>
    </FormControl>
    <FormControl>
      <Checkbox value="three" />
      <FormControl.Label>Choice three</FormControl.Label>
    </FormControl>
  </CheckboxGroup>
</>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      